import { INewProduct } from '../../../interfaces/NewProduct.interfaces';
import { customAxios } from '../../common/customAxios';

interface IGetNewProductByIdParams {
  productId: string;
}

/**
 * 신품 상세 정보를 조회하는 API 함수
 * @param productId - 조회할 신품의 고유 ID
 * @returns Promise<INewProduct> 신품 상세 정보
 */
export const getNewProductById = ({ productId }: IGetNewProductByIdParams): Promise<INewProduct> => {
  return customAxios.get(`/market/new-products/${productId}`);
};
